"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiArtifactStreemshotStatus = exports.StreemApiArtifactStreemshotToJSON = exports.StreemApiArtifactStreemshotFromJSONTyped = exports.StreemApiArtifactStreemshotFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiArtifactStreemshotFromJSON(json) {
    return StreemApiArtifactStreemshotFromJSONTyped(json, false);
}
exports.StreemApiArtifactStreemshotFromJSON = StreemApiArtifactStreemshotFromJSON;
function StreemApiArtifactStreemshotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'requestedAt': !(0, runtime_1.exists)(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'requestedByUserSid': !(0, runtime_1.exists)(json, 'requested_by_user_sid') ? undefined : json['requested_by_user_sid'],
        'requestedByDeviceSid': !(0, runtime_1.exists)(json, 'requested_by_device_sid') ? undefined : json['requested_by_device_sid'],
        'fulfilledAt': !(0, runtime_1.exists)(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'fulfilledByUserSid': !(0, runtime_1.exists)(json, 'fulfilled_by_user_sid') ? undefined : json['fulfilled_by_user_sid'],
        'fulfilledByDeviceSid': !(0, runtime_1.exists)(json, 'fulfilled_by_device_sid') ? undefined : json['fulfilled_by_device_sid'],
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : (0, _1.StreemApiArtifactStreemshotSourceFromJSON)(json['source']),
        'detections': !(0, runtime_1.exists)(json, 'detections') ? undefined : (json['detections'].map(_1.StreemApiDetectionFromJSON)),
        'currentRevision': !(0, runtime_1.exists)(json, 'current_revision') ? undefined : (0, _1.StreemApiArtifactStreemshotRevisionFromJSON)(json['current_revision']),
        'revisionNumber': !(0, runtime_1.exists)(json, 'revision_number') ? undefined : json['revision_number'],
        'note': !(0, runtime_1.exists)(json, 'note') ? undefined : (0, _1.StreemApiNoteFromJSON)(json['note']),
        'depthMap': !(0, runtime_1.exists)(json, 'depth_map') ? undefined : (0, _1.StreemApiArtifactStreemshotDepthMapFromJSON)(json['depth_map']),
    };
}
exports.StreemApiArtifactStreemshotFromJSONTyped = StreemApiArtifactStreemshotFromJSONTyped;
function StreemApiArtifactStreemshotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'requested_by_user_sid': value.requestedByUserSid,
        'requested_by_device_sid': value.requestedByDeviceSid,
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'fulfilled_by_user_sid': value.fulfilledByUserSid,
        'fulfilled_by_device_sid': value.fulfilledByDeviceSid,
        'source': (0, _1.StreemApiArtifactStreemshotSourceToJSON)(value.source),
        'detections': value.detections === undefined ? undefined : (value.detections.map(_1.StreemApiDetectionToJSON)),
        'current_revision': (0, _1.StreemApiArtifactStreemshotRevisionToJSON)(value.currentRevision),
        'revision_number': value.revisionNumber,
        'note': (0, _1.StreemApiNoteToJSON)(value.note),
        'depth_map': (0, _1.StreemApiArtifactStreemshotDepthMapToJSON)(value.depthMap),
    };
}
exports.StreemApiArtifactStreemshotToJSON = StreemApiArtifactStreemshotToJSON;
/**
* @export
* @enum {string}
*/
var StreemApiArtifactStreemshotStatus;
(function (StreemApiArtifactStreemshotStatus) {
    StreemApiArtifactStreemshotStatus["REQUESTED"] = "STATUS_REQUESTED";
    StreemApiArtifactStreemshotStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactStreemshotStatus["INVALID"] = "STATUS_INVALID";
})(StreemApiArtifactStreemshotStatus = exports.StreemApiArtifactStreemshotStatus || (exports.StreemApiArtifactStreemshotStatus = {}));
//# sourceMappingURL=StreemApiArtifactStreemshot.js.map